"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_NOTIFICATIONS_AS_READ = exports.SEND_LAB_REPORT_NOTIFICATION = exports.NOTIFICATION_PRODUCE_LABTEST = exports.NOTIFICATION_PRODUCE = exports.GET_NOTIFICATIONS = exports.CLEAR_ALL = void 0;
const GET_NOTIFICATIONS = exports.GET_NOTIFICATIONS = 'getNotifications';
const SET_NOTIFICATIONS_AS_READ = exports.SET_NOTIFICATIONS_AS_READ = 'setNotificationsAsRead';
const NOTIFICATION_PRODUCE = exports.NOTIFICATION_PRODUCE = 'notificationProduce';
const CLEAR_ALL = exports.CLEAR_ALL = 'clearall';
const NOTIFICATION_PRODUCE_LABTEST = exports.NOTIFICATION_PRODUCE_LABTEST = 'notificationProduceLabTest';
const SEND_LAB_REPORT_NOTIFICATION = exports.SEND_LAB_REPORT_NOTIFICATION = 'sendLabReportNotification';